import { useStore } from '../stores/useStore'

export function useLoginItems() {
  const loginItemIds = useStore((state) => state.config.loginItemIds ?? [])

  return loginItemIds
}
